export default __webpack_public_path__ + "static/steve-8da25cc941f8d1412403329ce1a9eb7d.png";